import { Component, OnInit, Input } from '@angular/core';
import { trigger, transition, useAnimation } from '@angular/animations';
import { fadeInDown } from 'ng-animate';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ConfirmdialogComponent } from '../../common/dialog/confirmdialog.component';
import { ApirequestService } from '../../../services/apirequest/apirequest.service';
import { ApiurlsService } from '../../../services/api-urls/apiurls.service';
import { Router } from '@angular/router';
import { UtilityService } from '../../../services/utilities/utilities.services';
import { OrderPipe } from 'ngx-order-pipe';


@Component({
  selector: 'hybse-admin-company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.css'],
  animations: [
    trigger('fadeInDown', [transition('* => *', useAnimation(fadeInDown, {
      params: {
        timing: 1,
        a: '-10px'
      }
    }))])
  ],
})
export class CompanyComponent implements OnInit {
  showLoader = true;
  newsList: any = [];
  fadeInDown: any;
  public errorMessage: string;
  listTitle = 'All News';
  public count: number;
  public limit = 50;
  public offset = 0;
  public filterType: number;

  // sorting
  reverse = false;
  order = 'title';
  sortedCollection: any[];

  constructor(public dialog: MatDialog,
    public _api: ApirequestService,
    public _urls: ApiurlsService,
    public _utils: UtilityService,
    public router: Router,
    private orderPipe: OrderPipe) {

  }

  ngOnInit() {
    this.getNewsList();
    this.sortedCollection = this.orderPipe.transform(this.newsList, this.order);
  }

  getNewsList() {
    const data = {
      offset: this.offset,
      limit: this.limit,
    };

    this.newsList = [];
    const url = this._urls.compListUrl;
    this._api.fetchApiData(url, data, 'get').subscribe(
      (res: any) => {
        const response = res.data;
        const resErr = res.error;
        if (response !== '') {
          this.newsList = response;
          this.count = response.length;
        } else {
          this.errorMessage = resErr['errorDescription'];
        }
      },
      error => {
        this.showLoader = false;
      },
      () => {
        this.showLoader = false;
      }
    );
  }

  confirmDelete(id) {
    const deleteDialog = this.dialog.open(ConfirmdialogComponent, {
      width: '400px',
      height: '170px',
      data: {
        message: 'Are you sure to delete this news?'
      }
    });

    deleteDialog.afterClosed().subscribe(
      data => {
        if (data) { this.deleteNews(id); }
      }
    );
  }

  checkActive(active, type) {
    if (active) {
      return type === 'bool' ? true : 'Active';
    } else {
      return type === 'bool' ? false : 'Inactive';
    }
  }

  editNews(id) {
      this.router.navigate(['/news/update', id]);
  }

  toggleActive(news, e) {
    const status = e.checked ? 'Active' : 'Inactive';
    const activeDialog = this.dialog.open(ConfirmdialogComponent, {
      width: '400px',
      height: '170px',
      data: {
        message: 'Are you sure to ' + status + ' the ' + news.id + '?'
      }
    });
    activeDialog.afterClosed().subscribe(
      data => {
        if (data) { this.toggleActiveNews(news.id, e); }
      }
    );
  }
  toggleActiveNews(id, e) {
    const data = {
      idExchangeNews: id,
      isPublished: e.checked ? 1 : 0
    };
    this._api.fetchApiData(this._urls.companyActiveUrl, data).subscribe(
      (res: any) => {
        const id = res.data.id;
        this.newsList = this._utils.changeArrayObjProp(this.newsList, 'id', id, 'ispublished', e.checked);
      },
      error => {

      },
      () => {

      }
    );
  }

  deleteNews(id) {
    const data = { idExchangeNews: id };
    this._api.fetchApiData(this._urls.companyDeleteUrl, data).subscribe(
      (res: any) => {
        const response = res;
        if (response !== 0) { this.deleteNewsFromList(id); }
      },
      error => {

      },
      () => {

      }
    );
  }

  deleteNewsFromList(id) {
    this.newsList = this._utils.filterArrayObj(this.newsList, 'id', id);
  }

  setOrder(value: string) {
    if (this.order === value) {
      this.reverse = !this.reverse;
    }
    if (value === 'createdat') {
      this.reverse ? this.filterType = 1 : this.filterType = 2;
      this.getNewsList();
    }
    if (value === 'title') {
      this.reverse ? this.filterType = 3 : this.filterType = 4;
      this.getNewsList();
    }
    this.order = value;
  }

  ngOnChanges() {
    this.listTitle = 'News List';
  }
}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/app/components/pages/company/company.component.ts